export class AysVirtualClinicNursing {

    constructor(
        public enrolledNurses: number,
        public enrolledChildrenNurses: number,
        public geriatricNurses: number,
        public nursingAssistants: number,
        public licensedPracticalNurses: number,
        public hospitalPorters: number,
        public deliveryNurses: number,
        public scrubNurses: number
    ) {
    }

    public static fromObj(obj: any): AysVirtualClinicNursing {
        return new AysVirtualClinicNursing(
            obj.enrolledNurses,
            obj.enrolledChildrenNurses,
            obj.geriatricNurses,
            obj.nursingAssistants,
            obj.licensedPracticalNurses,
            obj.hospitalPorters,
            obj.deliveryNurses,
            obj.scrubNurses
        );
    }
}

export class AysVirtualClinicMedical {

    constructor(
        public inpatientDocs: number,
        public nonSpecialists: number,
        public medicalSpecialists: number
    ) {
    }

    public static fromObj(obj: any): AysVirtualClinicMedical {
        return new AysVirtualClinicMedical(
            obj.inpatientDocs,
            obj.nonSpecialists,
            obj.medicalSpecialists
        );
    }
}
